import { $, RM } from "./util.js";

export function initCompare() {
  const c = $("#compare");
  const rng = $("#cmpRange");
  if (!c || !rng) return;
  let drag = false;

  const set = (p) => {
    p = Math.max(3, Math.min(97, p));
    c.style.setProperty("--pos", p + "%");
    rng.value = Math.round(p);
    rng.setAttribute("aria-valuetext", p < 50 ? "Showing more of doing it yourself" : "Showing more of Micro Reach");
  };
  const fromX = (x) => {
    const r = c.getBoundingClientRect();
    set(((x - r.left) / r.width) * 100);
  };
  c.addEventListener("pointerdown", (e) => {
    if (e.target === rng) return;
    drag = true;
    if (c.setPointerCapture) c.setPointerCapture(e.pointerId);
    fromX(e.clientX);
  });
  c.addEventListener("pointermove", (e) => {
    if (drag) fromX(e.clientX);
  });
  ["pointerup", "pointercancel"].forEach((t) => c.addEventListener(t, () => (drag = false)));
  rng.addEventListener("input", () => set(+rng.value));

  // Gentle hint animation once, when first seen.
  if (!RM && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (es) => {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        const s = performance.now();
        (function h(n) {
          const k = (n - s) / 1400;
          if (k > 1 || drag) {
            if (!drag) set(50);
            return;
          }
          set(50 + Math.sin(k * Math.PI * 2) * 14);
          requestAnimationFrame(h);
        })(s);
      },
      { threshold: 0.5 }
    );
    io.observe(c);
  }
}
